import { makeWidgetsList } from '@libs/core';
import { CoreProvider } from '@libs/theme';
import { selectRootWidgetUids, useAppSelector } from '@libs/store';
import Widget from './Widget';

const WidgetsList = makeWidgetsList(Widget);

export function App() {
    const rootWidgetUids = useAppSelector(selectRootWidgetUids);

    return (
        <CoreProvider>
            <WidgetsList uids={rootWidgetUids} />
        </CoreProvider>
    );
}
